import { Injectable } from '@angular/core';

import { ApiService, ApiCacheOptions, PagedSearch, PagedResult, PagedResultGeneric } from '../../../shared/index';
import { AddressType } from './dto/address-type.model';
import { AddressTypeSearchDto } from './dto/address-type-search.dto';

@Injectable()
export class AddressTypeService {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public search(searchDto: AddressTypeSearchDto, forceRefresh?: boolean): Promise<PagedResultGeneric<AddressType>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('Profiles/AddressTypes', searchDto, cacheOptions);
  }

  public get(id: number): Promise<AddressType> {
    return this._apiService.get(`Profiles/AddressType/${id}`);
  }

  public create(dto: AddressType): Promise<number> {
    return this._apiService.post('Profiles/AddressTypes', dto);
  }

  public update(dto: AddressType): Promise<void> {
    return this._apiService.put(`Profiles/AddressType/${dto.AddressTypeID}`, dto);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`Profiles/AddressType/${id}`);
  }

  public getDefaultBillingAndMailingAddressTypes = (): Promise<Array<AddressType>> => {
    var url = 'Profiles/AddressTypes/BillingAndMailingDefaults';
    return this._apiService.get(url, this._cacheOptions);
  };

  /*
   * Gets all address types
   */
  public getAddressTypes = (): Promise<Array<AddressType>> => {
    let cacheOptions: ApiCacheOptions = new ApiCacheOptions();
    // this won't change much, so don't check often
    cacheOptions.CacheSeconds = 3600;
    var url = 'Profiles/AddressTypes?PageSize=0&PageNumber=0';

    return this._apiService.getPaged(url, cacheOptions).then(
      (addressTypes) => {
        return addressTypes.Result;
      },
      (err) => err
    );
  };
}
